module.exports = __webpack_public_path__ + "img/lh-banner.94dc8ff4.png";